

























import { Component, Vue } from 'vue-property-decorator';
import {default as GameLogic, Hotspot, HotspotOption} from '@/services/GameLogic';
import VideoPlayer from '@/components/VideoPlayer.vue';
import Klokjes from '@/components/Klokjes.vue';
import LocaleText from "../components/LocaleText.vue";
import LocaleService from "../services/LocaleService";
import {TutorialTipPosition} from "../store/store";

const HOTSPOTNAME:string = 'communiceren';

@Component({
    data: function () {
        return {
            videoSkipped: false
        }
    },
    components: {
        LocaleText,
        VideoPlayer,
        Klokjes
    },
    created():void {
        this.$data.videoSkipped = this.$store.state.dayState.patientVideoViewed;
        //console.log('PatientMenu created: video skipped = ', this.$data.videoSkipped);
        this.$store.commit('showTip', { key: 'algemeen.tutorial.tip3.text', position: TutorialTipPosition.top });
    },
    computed: {
        getVpkRoute():string {
            return '/day/' + this.$route.params.day + '/nurse';
        },
        currentOptions():HotspotOption[] {
            const state = this.$store.state;
            const hotspot = GameLogic.getHotspotByName(state, HOTSPOTNAME);
            return GameLogic.getValidHotspotOptions(state, hotspot);
        },
        showOptions():boolean {
            return this.$store.state.dayState.patientVideoViewed
                && this.$store.state.currentOption === HotspotOption.NONE;
        },
        showOptionVideo():boolean {
            //console.log('showOptionVideo', this.$store.state.currentOption === HotspotOption.NONE);
            return this.$store.state.currentOption !== HotspotOption.NONE;
        },
        getVideoUrl():string {
            if( this.$store.state.currentOption === HotspotOption.NONE ) {
                return GameLogic.getPatientVideoUrl(this.$store.state, undefined);
            } else {
                return GameLogic.getPatientVideoUrl(this.$store.state, this.$store.state.currentOption.name);
            }
        }
    },
    methods: {
        handleVideoCompleted():void {
            this.$data.videoSkipped = true;
            this.$store.state.dayState.patientVideoViewed = true;
            this.$store.state.currentOption = HotspotOption.NONE;
        },
        handleOptionClicked(option:HotspotOption):void {
            this.$data.videoSkipped = false;
            this.$store.state.currentOption = option;
            const hotspot:Hotspot = GameLogic.getHotspotByName(this.$store.state, HOTSPOTNAME);
            GameLogic.executeOption(this.$store.state, hotspot, option);
        },
        handleCloseClicked():void {
            this.$router.push('/day/' + this.$route.params.day + '/nurse');
            //getVpkRoute
        },
        getOptionLabel(name:string):string {
            return LocaleService.optionDisplayName(this.$store.state, HOTSPOTNAME, name);
        }
    }
})
export default class PatientMenu extends Vue {
}
